import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const InputAddressContainer = styled.div`
  ${({ theme }) => css`
    margin: 36px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    padding: 24px;
    background: ${theme.colors.mainBg};
    box-shadow: 3px 3px 1px rgb(0 0 0 / 10%);
    border-radius: ${theme.border.radius};
    position: relative;

    .trash-button {
      background: transparent;
      position: absolute;
      top: 14px;
      right: 20px;
      cursor: pointer;
    }

    ${media.lessThan('medium')`
      padding: 0 12px;
      grid-template-columns: repeat(2, 1fr);

      .button-save-password {
        > svg {
          display: none;
        }
      }
    `}

    ${media.lessThan('small')`
      padding: 0 20px;
      grid-template-columns: repeat(1, 1fr);
    `}
  `}
`
